define.alias("shared/components/shared/social/facebook-page", "calendar/components/shared/social/facebook-page");